import { IChoiceStep } from '../types/steps';

import {
    ChoiceDisplay,
    ChoiceDisplayInstruction,
} from '../components/ChoiceDisplay';

import { colors } from '../constants';

import { BaseMaculaGrid } from '../svg';

export const macularDegenerationTestSteps: IChoiceStep[] = [
    {
        component: ChoiceDisplayInstruction,
        bgColor: colors.greenBg,
        props: {
            headerText: 'Bedek je <strong>linkeroog</strong>',
        },
    },
    {
        component: ChoiceDisplay,
        bgColor: colors.white,
        props: {
            question: 'Zie je de zwarte stip in het midden van het raster?',
            svgComponent: BaseMaculaGrid,
        },
    },
    {
        component: ChoiceDisplay,
        bgColor: colors.white,
        props: {
            question:
                'Als je naar de zwarte stip kijkt, zie je dan ook het hele raster?',
            svgComponent: BaseMaculaGrid,
        },
    },
    {
        component: ChoiceDisplay,
        bgColor: colors.white,
        props: {
            question:
                'Als je naar de zwarte stip kijkt, lopen de lijnen dan recht en parallel?',
            svgComponent: BaseMaculaGrid,
        },
    },
    {
        component: ChoiceDisplayInstruction,
        bgColor: colors.greenBg,
        props: {
            headerText: 'Bedek je <strong>rechter oog.</strong>',
        },
    },
    {
        component: ChoiceDisplay,
        bgColor: colors.white,
        props: {
            question: 'Zie je de zwarte stip in het midden van het raster?',
            svgComponent: BaseMaculaGrid,
        },
    },
    {
        component: ChoiceDisplay,
        bgColor: colors.white,
        props: {
            question:
                'Als je naar de zwarte stip kijkt, zie je dan ook het hele raster?',
            svgComponent: BaseMaculaGrid,
        },
    },
    {
        component: ChoiceDisplay,
        bgColor: colors.white,
        props: {
            question:
                'Als je naar de zwarte stip kijkt, lopen de lijnen dan recht en parallel?',
            svgComponent: BaseMaculaGrid,
        },
    },
];
